/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import Button from 'meinian-package/src/baseComponent/button'
import { message } from 'antd'
import { auth as userAuth } from 'meinian-package/src/utils'
import util from 'meinian-package/src/utils/util'
import { isPermissions, teamHasAuth } from 'meinian-package/src/utils/auth'
import { Dropdown } from 'meinian-package/src/baseComponent'
import { setSampleComplete } from 'component/imageDetail/sampleModal/common'
import SampleModal from 'component/imageDetail/sampleModal'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import { MARK_STATUS, getMarkStatusText, IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import './index.less'
import { useRequest } from 'ahooks'

// trackSourceType 存在则为来源为详情页
export default function Examine(props) {
  const {
    currentBlog,
    wrapperClassName,
    isRecallOperation = true,
    onCommentVisible,
    hiddenSample,
    hiddenDetailDelete,
    onInitiativeBehavior,
    trackSourceType,
    onChange,
    trackModule2,
    onDeleteItem,
    onResize,
    initSubColls,
    type = 'card',
  } = props
  const { markStatus, needMarkTimes, markTimes } = currentBlog || {}

  const buttonStyle = useMemo(() => {
    if (type === 'card') {
      return {
        flex: 1,
        width: '100%',
      }
    }
    return {}
  }, [])

  const renderDom = useMemo(() => {
    if (getMarkStatusText(markStatus, { isPass: true, maxLevel: needMarkTimes, level: markTimes })) {
      return (
        <>
          {isRecallOperation && <Examine.RecallOperation currentBlog={currentBlog} onChange={onChange} />}
          {!hiddenSample && (
            <Examine.Sample
              style={{ flex: '1' }}
              inspirationId={currentBlog.inspirationId}
              loginUserInfo={currentBlog.loginUserInfo}
              imageGroupEntityId={currentBlog.imageGroupEntityId}
              platformId={currentBlog.platformId}
              collectId={currentBlog.collectId}
            />
          )}
        </>
      )
    }
    if (MARK_STATUS.NOT_PASS === markStatus) {
      return (
        <>
          {isRecallOperation && <Examine.RecallOperation currentBlog={currentBlog} onChange={onChange} />}
          {!hiddenDetailDelete && (
            <Examine.Delete
              trackModule2={trackModule2}
              loginUserInfo={currentBlog.loginUserInfo}
              imageGroupEntityId={currentBlog.imageGroupEntityId}
              inspirationId={currentBlog.inspirationId}
              platformId={currentBlog.platformId}
              onDeleteItem={onDeleteItem}
              onResize={onResize}
              initSubColls={initSubColls}
              style={{ ...buttonStyle, marginRight: '8px' }}
            />
          )}
          <Examine.LeaveComment
            style={{ ...buttonStyle, marginRight: type === 'card' ? 0 : 8 }}
            onClick={(e) => {
              e.stopPropagation()
              onInitiativeBehavior(true)
              onCommentVisible?.((pre) => !pre)
            }}
          />
        </>
      )
    }
    const _onChange = (...arg) => {
      onInitiativeBehavior(false)
      onCommentVisible?.(true)
      if (trackSourceType) {
        util.track('mn-inspiration-examine', {
          module1: '款式详情',
        })
      } else {
        util.track('mn-inspiration-examine', {
          module1: '卡片',
        })
      }
      onChange?.(...arg)
    }
    return (
      <>
        {MARK_STATUS.UNSET === markStatus
        || (MARK_STATUS.PENDING === markStatus && markTimes === 0)
        || !isRecallOperation ? null : (
          <Examine.RecallOperation currentBlog={currentBlog} onChange={onChange} />
          )}
        <Examine.NotPass
          currentBlog={currentBlog}
          onChange={_onChange}
          style={{ ...buttonStyle, marginRight: '8px' }}
          className="normal-button"
          notPassIcon={<Icon className="not-pass-icon" type="m-juhui" />}
        />
        <Examine.Pass
          onChange={(...arg) => {
            if (trackSourceType) {
              util.track('mn-inspiration-examine', {
                module1: '款式详情',
              })
            } else {
              util.track('mn-inspiration-examine', {
                module1: '卡片',
              })
            }
            onChange?.(...arg)
          }}
          style={{ ...buttonStyle, marginRight: type === 'card' ? 0 : 8 }}
          currentBlog={currentBlog}
          className="normal-button"
          showPass={(MARK_STATUS.PENDING === markStatus || MARK_STATUS.UNSET === markStatus) && markTimes + 1 === needMarkTimes} // 二审通过应该显示三审通过
          passIcon={<Icon className="pass-icon" type="m-xiaoyan_miaobian" />}
        />
      </>
    )
  }, [markStatus, needMarkTimes, markTimes, isRecallOperation, currentBlog])

  return (
    <div className={classNames('meinian-examine-wrapper', wrapperClassName)} onClick={(e) => e && e.stopPropagation()}>
      {renderDom}
    </div>
  )
}

const Text = (props) => {
  const { currentBlog, className, showText = true } = props
  const { markStatus, needMarkTimes, markTimes } = currentBlog || {}

  const iconEnum = useMemo(() => {
    return {
      [MARK_STATUS.PASS]: <Icon type="m-xiaoyan_miaobian" />,
      [MARK_STATUS.NOT_PASS]: <Icon type="m-juhui" />,
      [MARK_STATUS.PENDING]: <Icon type="m-shijian" />,
      [MARK_STATUS.UNSET]: <Icon type="m-shijian" />,
    }
  }, [markStatus])

  const textEnum = useMemo(() => {
    if (!showText) {
      return
    }
    return (
      <span style={{ marginLeft: '4px' }}>{getMarkStatusText(markStatus, { maxLevel: needMarkTimes, level: markTimes })}</span>
    )
  }, [markStatus, needMarkTimes, markTimes])

  const switchText = useMemo(() => {
    return {
      [MARK_STATUS.PASS]: (
        <div className="show-icon">
          {iconEnum[markStatus]}
          {textEnum}
        </div>
      ),
      [MARK_STATUS.NOT_PASS]: (
        <div className="show-icon">
          {iconEnum[markStatus]}
          {textEnum}
        </div>
      ),
      [MARK_STATUS.PENDING]: (
        <div className="show-icon">
          {iconEnum[markStatus]}
          {textEnum}
        </div>
      ),
      [MARK_STATUS.UNSET]: (
        <div className="show-icon">
          {iconEnum[markStatus]}
          {textEnum}
        </div>
      ),
    }
  }, [markStatus, needMarkTimes, markTimes])

  return (
    <div
      className={classNames('mn-examine-text', className, {
        pass: markStatus === MARK_STATUS.PASS || (markStatus === MARK_STATUS.PENDING && markTimes !== 0),
        'not-pass': markStatus === MARK_STATUS.NOT_PASS,
        pending: (markStatus === MARK_STATUS.PENDING && markTimes === 0) || markStatus === MARK_STATUS.UNSET,
      })}
    >
      <div>{switchText[markStatus]}</div>
    </div>
  )
}

Examine.DetailText = (props) => {
  return (
    <>
      <Examine.Text {...props} />
      <div className="meinian-space" />
      {props.loginUserInfo?.role === IDEA_MASS_ROLE.GATHER
      || MARK_STATUS.UNSET === props.currentBlog.markStatus
      || (MARK_STATUS.PENDING === props.currentBlog.markStatus && props.currentBlog.markTimes === 0)
        ? null
        : isPermissions(props.auth, ['FCS09']) && (
        <Examine.RecallOperation isMenu {...props} className="style-detail-button-recall-operation" />
        )}
    </>
  )
}

Examine.Pass = (props) => {
  const { onChange, currentBlog, disabled, className, passIcon, showPass, hiddenReq = true, style } = props
  const { imageGroupEntityId, inspirationId, markStatus, needMarkTimes, markTimes } = currentBlog || {}

  const onPass = async () => {
    const _markTimes = markTimes + 1
    try {
      hiddenReq
        && (await request.post('/zhikuan/image-bus/update-mark-status', {
          entityId: imageGroupEntityId,
          inspirationId,
          markStatus: _markTimes === needMarkTimes || needMarkTimes === 0 ? MARK_STATUS.PASS : MARK_STATUS.PENDING,
          markTimes: _markTimes,
        }))
      onChange && onChange(_markTimes === needMarkTimes ? MARK_STATUS.PASS : MARK_STATUS.PENDING, _markTimes)
    } catch (err) {
      console.error(err)
    }
  }
  return (
    <Button onClick={onPass} disabled={disabled} className={classNames('df-center-center', className)} style={style}>
      {passIcon}
      {!showPass ? getMarkStatusText(markStatus, { maxLevel: needMarkTimes + 1, level: markTimes + 1 }) : '通过'}
    </Button>
  )
}
Examine.NotPass = (props) => {
  const { onChange, currentBlog, className, notPassIcon, hiddenReq = true, style } = props
  const { imageGroupEntityId, inspirationId, markTimes } = currentBlog || {}

  const onNotPass = async () => {
    const _markTimes = markTimes + 1
    try {
      hiddenReq
        && (await request.post('/zhikuan/image-bus/update-mark-status', {
          entityId: imageGroupEntityId,
          inspirationId,
          markTimes: _markTimes,
          markStatus: MARK_STATUS.NOT_PASS,
        }))
      onChange && onChange(MARK_STATUS.NOT_PASS, _markTimes)
    } catch (err) {
      message.warning(err?.errorDesc)
    }
  }
  return (
    <Button type="error" onClick={onNotPass} style={style} className={classNames('df-center-center', className)}>
      {notPassIcon}不通过
    </Button>
  )
}

Examine.Remark = (props) => {
  const { onChange, currentBlog, hiddenReq = true, className, disabled, style } = props
  const { imageGroupEntityId, inspirationId } = currentBlog || {}

  const onRemark = async () => {
    ModalConfirm.show({
      title: '提示',
      content: '重新审核后，款式的原审核状态将会被更新。你确定要重新审核款式？',
      onOk: async () => {
        try {
          hiddenReq
            && (await request.post('/zhikuan/image-bus/update-mark-status', {
              entityId: imageGroupEntityId,
              inspirationId,
              markStatus: MARK_STATUS.PENDING,
            }))
          onChange && onChange(MARK_STATUS.PENDING)
        } catch (err) {
          console.error(err)
          message.warning(err?.errorDesc)
        }
      },
    })
  }
  return (
    <Button disabled={disabled} className={classNames(className)} style={style} onClick={onRemark}>
      重新审核
    </Button>
  )
}

Examine.Recall = (props) => {
  const { onChange, currentBlog, className, style } = props
  const { imageGroupEntityId, inspirationId } = currentBlog || {}

  const onRecall = async (e) => {
    e?.stopPropagation()
    try {
      await request.post('/zhikuan/image-bus/update-mark-status', {
        entityId: imageGroupEntityId,
        inspirationId,
        markTimes: 0,
        markStatus: MARK_STATUS.UNSET,
      })
      onChange && onChange(MARK_STATUS.UNSET)
      message.success('撤回成功')
    } catch (err) {
      console.error(err)
      message.warning(err?.errorDesc)
    }
  }
  return (
    <Button type="normal" style={style} onClick={onRecall} className={classNames(className)}>
      撤回提审
    </Button>
  )
}

Examine.Commit = (props) => {
  const { onChange, currentBlog, className, style } = props
  const { imageGroupEntityId, inspirationId } = currentBlog || {}

  const onCommit = async (e) => {
    e?.stopPropagation()
    try {
      await request.post('/zhikuan/image-bus/update-mark-status', {
        entityId: imageGroupEntityId,
        inspirationId,
        markTimes: 0,
        markStatus: MARK_STATUS.PENDING,
      })
      onChange && onChange(MARK_STATUS.PENDING, 0)
      message.success('提交审核')
    } catch (err) {
      console.error(err)
      message.warning(err?.errorDesc)
    }
  }
  return (
    <Button type="normal" style={style} onClick={onCommit} className={classNames(className)}>
      提交审核
    </Button>
  )
}

Examine.Delete = ({
  className,
  loginUserInfo,
  imageGroupEntityId,
  inspirationId,
  platformId,
  trackModule2,
  onDeleteItem,
  onResize,
  initSubColls,
  style,
}) => {
  const auth = loginUserInfo?.inspirationPermissions || []
  const remove = (e) => {
    e.stopPropagation()
    if (!userAuth.isPermissions(auth, ['FS03', 'FCS03', 'FS03_CREATOR', 'FCS03_CREATOR'])) {
      message.error(platformId === PLATFORM_VALUE.UPLOAD ? '仅能移除自己上传的图片哦' : '仅能移除自己采集的款式哦')
      return
    }
    ModalConfirm.show({
      title: '确认删除款式？',
      content: '当款式被删除后，在回收站保留30天，超过30天将无法恢复。',
      onOk: async () => {
        try {
          await request.post('/zhikuan/ins/inspiration/remove-from-inspiration', {
            blogList: [{ blogId: imageGroupEntityId }],
            inspirationId,
          })
          message.success('已成功删除')
          onDeleteItem?.()
          onResize?.()
          initSubColls?.()
        } catch (err) {
          console.error('/zhikuan/ins/inspiration/remove-from-inspiration', err)
        }
      },
    })
    if (window.location.pathname.startsWith('/meinian/home/workbench')) {
      util.track('mn-workbench-click', {
        module1: '款式查看',
        module2: trackModule2,
        module3: '删除款式',
      })
    }
  }
  return (
    isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) && (
      <Button type="normal" onClick={remove} className={classNames(className)} style={style}>
        删除
      </Button>
    )
  )
}

Examine.Sample = ({ className, inspirationId, loginUserInfo, imageGroupEntityId, platformId, collectId, style }) => {
  const addSampleInfo = [{ inspirationId, blogId: imageGroupEntityId, platformId, collectId }]
  const auth = loginUserInfo?.inspirationPermissions || []

  const onOkSampleModal = async (processId, option) => {
    addSampleInfo[0].processId = processId
    await setSampleComplete([{ ...addSampleInfo[0], ...option }])
  }
  const onCreateSample = async (e) => {
    e.stopPropagation()
    request.track({ code: 6400035, type: '款式详情-生成样衣' })
    SampleModal.show({
      authList: auth,
      onOk: onOkSampleModal,
    })
  }
  return (
    isPermissions(auth, ['FS13', 'FCS14'])
    && teamHasAuth('meinian_sample_clothing') && (
      <Button style={style} type="normal" onClick={onCreateSample} className={classNames(className)}>
        设为样衣
      </Button>
    )
  )
}

Examine.RecallOperation = ({ className, isMenu = false, ...props }) => {
  const { onChange, currentBlog } = props
  const { imageGroupEntityId, inspirationId, markStatus, markTimes, collectId, needMarkTimes } = currentBlog || {}

  const onRecall = async (e) => {
    e.stopPropagation()

    ModalConfirm.show({
      title: '是否撤回!',
      content: '',
      onOk: async () => {
        const temp = {
          markTimes: 0,
          markStatus: MARK_STATUS.PENDING,
        }

        if (markStatus === MARK_STATUS.PENDING && markTimes !== 0) {
          // 审核中之后才有撤回 审核中分为 markTimes ===0 和 markTime!==0
          temp.markTimes = markTimes ? markTimes - 1 : 0
        } else if (markStatus === MARK_STATUS.NOT_PASS) {
          // 审核失败的撤回
          temp.markTimes = markTimes ? markTimes - 1 : 0
        } else if (markStatus === MARK_STATUS.PASS) {
          temp.markStatus = MARK_STATUS.PENDING
          temp.markTimes = needMarkTimes - 1
        }

        await request.post('/zhikuan/image-bus/update-mark-status', {
          entityId: imageGroupEntityId,
          inspirationId,
          markTimes: temp.markTimes,
          markStatus: temp.markStatus,
        })
        onChange && onChange(temp.markStatus, temp.markTimes)
      },
    })
  }

  const onRemark = async (e) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '是否重置！',
      content: '重置为待审核',
      onOk: async () => {
        await request.post('/zhikuan/ins/inspiration/batch-reset-mark-status', {
          collectIdList: [collectId],
          inspirationId,
          markTimes: 0,
          markStatus: MARK_STATUS.PENDING,
        })
        onChange && onChange(MARK_STATUS.PENDING, 0)
      },
    })
  }

  const menu = (
    <div className="mn-recall-operation-menu">
      <div className="mn-recall-operation-menu-item fill-white-bg" onClick={onRecall}>
        <Icon type="m-chehui" className="mn-recall-operation-menu-item-icon" />
        撤回
      </div>
      <div className="mn-recall-operation-menu-item fill-white-bg" onClick={onRemark}>
        <Icon type="m-gengxin" className="mn-recall-operation-menu-item-icon" />
        重置
      </div>
    </div>
  )
  if (isMenu) {
    return (
      <Dropdown trigger="click" overlay={menu} placement="topRight" className="mn-recall-dropdown">
        <a className={classNames('mn-recall-operation', 'fill-white-bg', className)}>
          <Icon type="m-chehui" />
        </a>
      </Dropdown>
    )
  }
  return (
    <a onClick={onRecall} className={classNames('mn-recall-operation', 'fill-white-bg', className)}>
      <Icon type="m-chehui" />
    </a>
  )
}

Examine.LeaveComment = ({ className, style, ...otherProps }) => {
  return (
    <Button type="normal" className={classNames(className)} style={style} {...otherProps}>
      留言评论
    </Button>
  )
}

Examine.Text = Text

// 投票功能
Examine.Vote = ({ runImgsData, onInitCommentTotal, currentBlog, className, style, ...otherProps }) => {
  const [isVoted, setIsVoted] = useState(false)
  useEffect(() => {
    setIsVoted(currentBlog?.voteStatus)
  }, [currentBlog?.voteStatus])
  const refresh = () => {
    runImgsData?.()
    onInitCommentTotal?.()
  }
  const { run: addVote } = useRequest(() => request.post('/zhikuan/ins/inspiration/add-user-comment-vote', {
    collectOrSampleId: currentBlog.collectId,
    type: 0
  }), {
    manual: true,
    onSuccess: refresh,
    onError: () => message.error('操作失败')
  })
  const { run: removeVote } = useRequest(() => request.post('/zhikuan/ins/inspiration/remove-user-comment-vote', {
    collectOrSampleId: currentBlog.collectId,
    type: 0
  }), {
    manual: true,
    onSuccess: refresh,
    onError: () => message.error('操作失败')
  })
  return (
    <Button onClick={isVoted ? removeVote : addVote} type="normal" className={classNames(className)} style={style} {...otherProps}>
      {isVoted ? '已投票' : '投票'}
    </Button>
  )
}
